import React from 'react';
import { FiPlus, FiList } from 'react-icons/fi';
import { getUserInfo } from '_utils/localData';
import './style.scss';

export default function ButtonItemAction({ onAddItem, onAddFromCatalogue }) {
  const userInfo = getUserInfo();
  const isUsingFeature = Boolean(userInfo?.isUsingFeature);

  return (
    <div className="add-item-actions">
      <div className="add-item-btn" onClick={onAddItem}>
        <FiPlus size={16} />
        <span>Add Item</span>
      </div>
      {isUsingFeature && (
        <div className="add-item-btn catalogue-btn" onClick={onAddFromCatalogue}>
          <FiList size={16} />
          <span>Product Catalogue</span>
        </div>
      )}
    </div>
  );
}
